export const setting_update_api = "https://wishlist.ens.enterprises/setting/settingsupdate";
export const setting_get_api = "https://wishlist.ens.enterprises/setting/getsettings/";
export const support_mail_api = "https://wishlist.ens.enterprises/support/supportMail";
export const shopify_api = "https://wishlist.ens.enterprises/shopify";
export const get_plan_api = "https://wishlist.ens.enterprises/plan/getPlanDetail";
export const plan_create_api = "https://wishlist.ens.enterprises/plan/planCreate";
export const free_plan_api = "https://wishlist.ens.enterprises/plan/freePlan";